window.wizaah = window.wizaah || {};

wizaah.RecentlyViewedProducts = (function() {
  function RecentlyViewedProducts(element) {
  	this.container = document.querySelector('[data-section-type="' + element + '"]');
    
    if(!this.container) {
      return;
    }
    
    this.options = JSON.parse(this.container.getAttribute('data-section-settings'));

    if (this.options['productId']) {
      this.saveCurrentProduct();
    }
    
    this.fetchProducts();
    this.attachEventListeners();
  }
  
  RecentlyViewedProducts.prototype.attachEventListeners = function() {
    //ADD ANY EVENTLISTNRES LIKE :: ADD TO CART, QUICK VIEW ETC..
  }
  
  RecentlyViewedProducts.prototype.fetchProducts = function() {
  	var _this = this;   
    var queryString = this.getSearchQueryString();

    if (queryString === '') {
      return;
    }
    
    fetch(("/search?view=wizaah-recently-viewed-products&type=product&q=").concat(queryString), {
      credentials: 'same-origin',
      method: 'GET'
    })
    .then(function (response) {
      response.text().then(function (content) {
      	var blankDivElement = document.createElement('div');
        blankDivElement.innerHTML = content;
        
        _this.container.querySelector('.recentlyviewed__container').innerHTML = blankDivElement.querySelector('[data-section-type="wizaah-recently-viewed-products"] .recentlyviewed__container').innerHTML;
		_this.container.parentNode.style.display = 'block';
        
        _this.initSlider();
      })
    })
  }
  
  RecentlyViewedProducts.prototype.saveCurrentProduct = function() {
    /*
     * - Check if the current product already exists, and if it does not, add it at the start
     * - Then, we save the current product into the local storage, by keeping only the 8 most recent
    */    
    var items = JSON.parse(localStorage.getItem('mmRecentlyViewedProducts') || '[]'),
        productId = this.options['productId']; 

    if (!items.includes(productId)) {
      items.unshift(productId);
    }
    
    try {
      localStorage.setItem('mmRecentlyViewedProducts', JSON.stringify(items.slice(0, 8)));
    } 
    catch (error) {}
  }
  
  RecentlyViewedProducts.prototype.getSearchQueryString = function() {
    var items = JSON.parse(localStorage.getItem('mmRecentlyViewedProducts') || '[]');
	
    if (items.includes(this.options['productId'])) {
      items.splice(items.indexOf(this.options['productId']), 1);
    }

    return items.map(function (item) {
      return 'id:' + item;
    }).join(' OR ');
  }
  
  RecentlyViewedProducts.prototype.initSlider = function() {
    $('.home-prd-card').owlCarousel({
      loop: false,
      margin: 10,
      nav: true,
      dots: false,
      center: false,
      navText: [
        '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M43.75 15L6.25 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M15 6.25L6.25 15L15 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
        '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M6.25 15L43.75 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M35 6.25L43.75 15L35 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
      ],
      responsive: {
        0: {
          items: 2,
          nav: false,
          dots: true,
          margin: 6,
        },
        768: {
          items: 4,
          margin: 4,
        },
        1200: {
          items: 4,
        },
      },
    });
  }
  
  return RecentlyViewedProducts;
})();

new wizaah.RecentlyViewedProducts('wizaah-recently-viewed-products');